function variables() {
    var bbMercadoPagoUrlLib = 'https://sdk.mercadopago.com/js/v2';
    var bbfConfig;
    var bbUrlBase = '';
    var bbToken = '';
    var bbfButtonId;
    var bbOrderId = 0;
    var bbfButton;
    var bbMpagoLibLoaded = false;
    var bbFunctionReturn = () => {};
    var mPMadalRef;
    var bbStatusEnum = {
        pending: 0,
        completed: 1,
        incompleted: 2,
        cancelled: 3,
        unknown: 4
    };
    var isFinalized = false;

    var mpModeEnum = {
        Modal: 0,
        Redirect: 1,
        IFrame: 2
    };
    var bbGetStatusCounter = 0;
    var prevMessage;
    var timeoutRef;

    Object.defineProperty(this, 'timeoutRef', {
        get: () => timeoutRef,
        set: (value) => timeoutRef = value
    });
    Object.defineProperty(this, 'prevMessage', {
        get: () => prevMessage,
        set: (value) => prevMessage = value
    });
    Object.defineProperty(this, 'isFinalized', {
        get: () => isFinalized,
        set: (value) => isFinalized = value
    });
    Object.defineProperty(this, 'mPMadalRef', {
        get: () => mPMadalRef,
        set: (value) => mPMadalRef = value
    });
    Object.defineProperty(this, 'mpModeEnum', {
        get: () => mpModeEnum,
        set: (value) => mpModeEnum = value
    });
    Object.defineProperty(this, 'bbMercadoPagoUrlLib', {
        get: () => bbMercadoPagoUrlLib,
        set: (value) => bbMercadoPagoUrlLib = value
    });
    Object.defineProperty(this, 'bbfConfig', {
        get: () => bbfConfig,
        set: (value) => bbfConfig = value
    });
    Object.defineProperty(this, 'bbUrlBase', {
        get: () => bbUrlBase,
        set: (value) => bbUrlBase = value
    });
    Object.defineProperty(this, 'bbToken', {
        get: () => bbToken,
        set: (value) => bbToken = value
    });
    Object.defineProperty(this, 'bbfButtonId', {
        get: () => bbfButtonId,
        set: (value) => bbfButtonId = value
    });
    Object.defineProperty(this, 'bbOrderId', {
        get: () => bbOrderId,
        set: (value) => bbOrderId = value
    });
    Object.defineProperty(this, 'bbfButton', {
        get: () => bbfButton,
        set: (value) => bbfButton = value
    });
    Object.defineProperty(this, 'bbMpagoLibLoaded', {
        get: () => bbMpagoLibLoaded,
        set: (value) => bbMpagoLibLoaded = value
    });
    Object.defineProperty(this, 'bbFunctionReturn', {
        get: () => bbFunctionReturn,
        set: (value) => bbFunctionReturn = value
    });
    Object.defineProperty(this, 'bbStatusEnum', {
        get: () => bbStatusEnum,
        set: (value) => bbStatusEnum = value
    });
    Object.defineProperty(this, 'bbGetStatusCounter', {
        get: () => bbGetStatusCounter,
        set: (value) => bbGetStatusCounter = value
    });
    Object.defineProperty(this, 'bbAceptepParams', {
        get: () => bbAceptepParams,
        set: (value) => bbAceptepParams = value
    });
}

export default variables;